import { Col } from 'reactstrap';
import { UL, H4 } from '../../../AbstractElements';
import { WeatherDataOb } from '../../../Data/Widgets/general';

const WeatherWidgetList = () => {
  return (
    <Col xl='7' md='6'>
      <div className='widget-list'>
        <UL className='simple-list'>
          {WeatherDataOb.map((item, i) => (
            <li key={i}>
              <div className='d-flex'>
                {item.icon}
                <div className='text-white flex-grow-1'>
                  <H4 className='m-0 f-w-600 num'>{item.temp}*C</H4>
                </div>
                <span>{item.title}</span>
              </div>
            </li>
          ))}
        </UL>
      </div>
    </Col>
  );
};

export default WeatherWidgetList;
